import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import patternRightInverted from '@patterns/rightInverted';
import ActiveCampaignForm from '../../ActiveCampaignForm';
import * as styles from './style.module.scss';
const { postAd, postAd__content, postAd__title, postAd__text, postAd__image } =
  styles;

const PostAd = ({ content }) => {
  const img = getImage(content.image);

  return (
    <section className={postAd}>
      {patternRightInverted}
      <div className={postAd__content}>
        <h3 className={postAd__title}>{content.headline}</h3>
        <p className={postAd__text}>{content.paragraph}</p>
        {content.buttonUrl && (
          <a
            href={content.buttonUrl}
            className="button button--primary button--large"
          >
            {content.buttonCopy}
          </a>
        )}
        {content.campaignId && (
          <ActiveCampaignForm
            id="ad-form"
            formId={content.campaignId}
            className="active-campaign-form-ad"
          />
        )}
      </div>
      {img && (
        <GatsbyImage
          className={postAd__image}
          image={img}
          alt={content.image.title}
        />
      )}
    </section>
  );
};

export default PostAd;

